const PROFILE_RENDERERS = new Set(["csp", "rsp", "gsp"]);
const HIDDEN_RESPONSE_TYPES = new Set([
  "round_listing",
  "operation_listing",
  "operation_list",
  "data_coverage",
  "country_profile",
  "regional_profile",
  "global_profile",
  "regional_overview",
  "global_overview",
  "csp",
  "rsp",
  "gsp",
]);
const HIDDEN_ROUTES = new Set([
  "CSP",
  "RSP",
  "GSP",
  "DATA_COVERAGE",
  "REGIONAL_OVERVIEW",
  "GLOBAL_OVERVIEW",
]);
const HIDDEN_QUERY_TYPES = new Set([
  "round_listing",
  "operation_listing",
  "operation_list",
  "data_coverage",
]);

const normalized = (value) => String(value || "").trim().toLowerCase();

const getAnalysisType = (response) => {
  const analysis = response?.response_type_analysis;
  return normalized(typeof analysis === "object" ? analysis?.type : analysis);
};

const getQueryType = (response) =>
  normalized(
    response?.query_type ||
      response?.ids?.query_type ||
      response?.debug?.ids?.query_type ||
      response?.debug?.aep?.query_type,
  );

const isFlatRecordArray = (value) =>
  Array.isArray(value) &&
  value.length > 0 &&
  value.every(
    (row) => row && typeof row === "object" && !Array.isArray(row),
  );

export const getVisualizationEligibility = (response) => {
  const config = response?.visualization_config;
  const configuredRenderer = normalized(config?.renderer);
  const responseType = normalized(response?.response_type);
  const route = String(response?.route || "").trim().toUpperCase();
  const analysisType = getAnalysisType(response);
  const queryType = getQueryType(response);
  const summarySource = normalized(response?.summary_source);
  const statusState = normalized(response?.response_status?.state);

  if (config?.enabled === false) {
    return { eligible: false, renderer: null, reason: "disabled_by_config" };
  }
  if (PROFILE_RENDERERS.has(configuredRenderer)) {
    return { eligible: false, renderer: null, reason: "dedicated_renderer_required" };
  }
  if (configuredRenderer && configuredRenderer !== "generic") {
    return { eligible: false, renderer: null, reason: "unsupported_renderer" };
  }
  if (
    HIDDEN_RESPONSE_TYPES.has(responseType) ||
    HIDDEN_ROUTES.has(route) ||
    PROFILE_RENDERERS.has(analysisType) ||
    HIDDEN_QUERY_TYPES.has(queryType) ||
    summarySource.includes("round_listing") ||
    Boolean(response?.profile) ||
    Boolean(response?.regional_overview) ||
    Boolean(response?.global_overview)
  ) {
    return { eligible: false, renderer: null, reason: "response_category_excluded" };
  }
  if (statusState && statusState !== "success") {
    return { eligible: false, renderer: null, reason: "response_not_successful" };
  }
  if (!isFlatRecordArray(response?.query_result)) {
    return { eligible: false, renderer: null, reason: "missing_flat_query_result" };
  }

  return {
    eligible: true,
    renderer: "generic",
    reason: config?.enabled === true ? "configured_generic" : "compatible_flat_result",
    dataSource: "query_result",
    ranking: analysisType === "ranking",
  };
};

export default getVisualizationEligibility;
